import { render } from "./AvatarButtons.vue?vue&type=template&id=11b34ace&scoped=true"
import script from "./AvatarButtons.vue?vue&type=script&lang=js"
export * from "./AvatarButtons.vue?vue&type=script&lang=js"

import "./AvatarButtons.vue?vue&type=style&index=0&id=11b34ace&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b34ace"]])

export default __exports__